module.exports = __webpack_public_path__ + "img/g2.8b33c0c7.jpg";